import Api from '../api';
let uri = '/api/ed/capacitacion';

export const validaRepitencia = (data) => {
    return Api.getInstance().executeQuery(`${uri}/repitencia`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const capacitacionesPendientes = (data) => {
    return Api.getInstance().executeQuery(`${uri}/pendientes`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const generarActa = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const registroParticpante = (data) => {
    return Api.getInstance().executeQuery(`${uri}/cliente`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getClientesCapacitacion = (data) => {
    return Api.getInstance().executeQuery(`${uri}/clientes`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getInvitadosCapacitacion = (data) => {
    return Api.getInstance().executeQuery(`${uri}/invitados`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const registroPotencial = (data) => {
    return Api.getInstance().executeQuery(`${uri}/potencial`, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const actaSatisfaccion = (data) => {
    return Api.getInstance().executeQuery(`${uri}/satisfaccion`, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const editActa = (data)  => {
    return Api.getInstance().executeUpdateQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const getHistorialActa = (data) => {
    return Api.getInstance().executeQuery(`${uri}/historial`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}






